import { useCurrentCompany } from './use-current-company';

/**
 * Company-scope Bizy early-access eligibility — answers "should this company
 * see the Bizy opt-in / waitlist CTA?" (BIZY-322)
 *
 * Backed by `company.bizy_early_access_eligible` from the CompanyBlueprint,
 * which is true only for Org-plan customers not yet in the
 * bizy-for-participation program. The frontend never re-derives plan logic.
 *
 * Opting in records interest only — it does NOT enable Bizy. For the "is Bizy
 * actually available?" question, use `useIsBizyEnabledForCompany`.
 */
export function useIsBizyEarlyAccessEligible(): boolean {
	const company = useCurrentCompany();
	return company?.bizy_early_access_eligible ?? false;
}
